// Esta instrução é usada para criar um canal de comunicação entre o formulário ListaEmpresas e o 
// formulário CadastroEmpresas, permitindo que eles compartilhem informações em tempo real. 
export const channel = new BroadcastChannel('empresas-channel')
